<div class="mx-lg p-6">
  <div class="p-6">

    <!-- Summary of everything that still needs attention. Each entry jumps to its field. -->
    @if (visibleErrors().length) {
    <div class="mb-6 rounded-lg border border-red-300 bg-red-50 p-4" role="alert">
      <div class="flex items-start gap-2">
        <svg class="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-9 4a1 1 0 102 0 1 1 0 00-2 0zm1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd" />
        </svg>
        <div>
          <p class="text-sm font-semibold text-red-800">
            {{ visibleErrors().length === 1 ? 'One field needs attention' : visibleErrors().length + ' fields need attention' }}
          </p>
          <ul class="mt-2 space-y-1">
            @for (error of visibleErrors(); track error.field) {
            <li class="text-sm text-red-700">
              <button type="button" (click)="goToField(error.field)"
                class="font-medium underline underline-offset-2 hover:text-red-900">
                {{ error.label }}
              </button>
              <span class="text-red-600"> — {{ error.message }}</span>
            </li>
            }
          </ul>
        </div>
      </div>
    </div>
    }

    <!-- General Details Section -->
    <div class="mb-6">
      <h3 class="text-lg font-semibold text-gray-900 mb-4">General Details</h3>
      <div class="grid lg:grid-cols-4 md:grid-cols-2 xs:grid-cols-1 gap-4">

        <!-- Customer Name -->
        <div class="relative" id="field-customerName">
          <input type="text" id="customerName" class="textField peer" placeholder=" "
                 [class.!border-red-500]="errorFor('customerName')"
                 [(ngModel)]="customer().customerName"
                 (ngModelChange)="updateField('customerName', $event)"
                 required>
          <label class="label" for="customerName">Customer Name <span class="text-red-700">*</span></label>
          @if (errorFor('customerName'); as message) {
          <p class="mt-1 text-xs text-red-600">{{ message }}</p>
          }
        </div>
                <!-- Invoice Type -->
        <div id="field-invoiceTypeId">
          <div class="rounded-lg" [class.ring-1]="errorFor('invoiceTypeId')"
            [class.ring-red-500]="errorFor('invoiceTypeId')">
            <app-search-invoice-type
              [disabled]=false
              [resetTrigger]="resetSearchTrigger()"
              [InvoiceTypeInput]="customer().invoiceTypeId"
              (selectedInvoiceType)="onFieldSelected('invoiceTypeId', $event)">
            </app-search-invoice-type>
          </div>
          @if (errorFor('invoiceTypeId'); as message) {
          <p class="mt-1 text-xs text-red-600">{{ message }}</p>
          }
        </div>

                <!--VAT Reg Number -->

        <div class="relative" id="field-customerVatRegNo">
    <input type="text" id="customerVatRegNo" class="textField peer" placeholder=" "
        [class.!border-red-500]="errorFor('customerVatRegNo')"
        [(ngModel)]="customer().customerVatRegNo" autocomplete="off"
        (ngModelChange)="updateField('customerVatRegNo', $event)" name="customerVatRegNo">
    <label class="label" for="customerVatRegNo">
        VAT Reg Number
        @if (isVatRequired()) {
            <span class="text-red-700">*</span>
        }
    </label>
    @if (errorFor('customerVatRegNo'); as message) {
    <p class="mt-1 text-xs text-red-600">{{ message }}</p>
    }
</div>
        <!-- SVAT Reg Number -->
<div class="relative" id="field-customerSvatRegNo">
    <input type="text" id="customerSvatRegNo" class="textField peer" placeholder=" "
        [class.!border-red-500]="errorFor('customerSvatRegNo')"
        [(ngModel)]="customer().customerSvatRegNo" autocomplete="off"
        (ngModelChange)="updateField('customerSvatRegNo', $event)" name="customerSvatRegNo">
    <label class="label" for="customerSvatRegNo">
        SVAT Reg Number
        @if (isVatRequired()) {
            <span class="text-red-700">*</span>
        }
    </label>
    @if (errorFor('customerSvatRegNo'); as message) {
    <p class="mt-1 text-xs text-red-600">{{ message }}</p>
    }
</div>

<div id="field-paymentTerm">
  <div class="rounded-lg" [class.ring-1]="errorFor('paymentTerm')" [class.ring-red-500]="errorFor('paymentTerm')">
    <app-search-payment-terms
        [disabled]="false"
        [resetTrigger]="resetSearchTrigger()"
        [paymentTermInput]="customer().paymentTerm"
        (selectPaymentTerm)="onFieldSelected('paymentTerm',$event)">
    </app-search-payment-terms>
  </div>
  @if (errorFor('paymentTerm'); as message) {
  <p class="mt-1 text-xs text-red-600">{{ message }}</p>
  }
</div>

        <!-- Credit Period -->
         @if(customer().paymentTerm =="cr"){
        <div class="relative" id="field-creditPeriod">
          <input type="number" id="creditPeriod" class="textField peer" placeholder=" "
                 [class.!border-red-500]="errorFor('creditPeriod')"
                 [(ngModel)]="customer().creditPeriod"
                 (ngModelChange)="updateField('creditPeriod', $event)" positiveNumberOnly>
          <label class="label" for="creditPeriod">Credit Period (Days)<span class="text-red-700">*</span></label>
          @if (errorFor('creditPeriod'); as message) {
          <p class="mt-1 text-xs text-red-600">{{ message }}</p>
          }
        </div>
      }
        <!-- Preferred Currency -->
        <div id="field-currencyId">
          <div class="rounded-lg" [class.ring-1]="errorFor('currencyId')" [class.ring-red-500]="errorFor('currencyId')">
            <app-search-currency
              [disabled]=false
              [resetTrigger]="resetSearchTrigger()"
              [currencyInput]="customer().currencyId"
              (selectCurrency)="onFieldSelected('currencyId', $event)">
            </app-search-currency>
          </div>
          @if (errorFor('currencyId'); as message) {
          <p class="mt-1 text-xs text-red-600">{{ message }}</p>
          }
        </div>

        <!-- Phone Number 1 -->
        <div class="relative">
          <input type="tel" id="telephoneNo" class="textField peer" placeholder=" "
                 [(ngModel)]="customer().telephoneNo"
                 (ngModelChange)="updateField('telephoneNo', $event)"
                 phoneNumberOnly>
          <label class="label" for="telephoneNo">Phone Number</label>
        </div>

        <!-- Fax -->
        <div class="relative">
          <input type="text" id="faxNo" class="textField peer" placeholder=" "
                 [(ngModel)]="customer().faxNo"
                 (ngModelChange)="updateField('faxNo', $event)"
                 phoneNumberOnly>
          <label class="label" for="faxNo">Fax</label>
        </div>

        <!-- Email -->
        <div class="relative" id="field-emailAddress">
          <input type="emailAddress" id="emailAddress" class="textField peer" placeholder=" "
                 [class.!border-red-500]="errorFor('emailAddress')"
                 [(ngModel)]="customer().emailAddress"
                 (ngModelChange)="updateField('emailAddress', $event)">
          <label class="label" for="emailAddress">Email</label>
          @if (errorFor('emailAddress'); as message) {
          <p class="mt-1 text-xs text-red-600">{{ message }}</p>
          }
        </div>

        <!-- Sales Owner -->
        <div id="field-salesOwnerId">
          <div class="rounded-lg" [class.ring-1]="errorFor('salesOwnerId')"
            [class.ring-red-500]="errorFor('salesOwnerId')">
            <app-search-sales-executive
              [resetTrigger]="resetSearchTrigger()"
              [salesOwnerId]="customer().salesOwnerId"
              (selectedSalesOwnerId)="onFieldSelected('salesOwnerId', $event)">
            </app-search-sales-executive>
          </div>
          @if (errorFor('salesOwnerId'); as message) {
          <p class="mt-1 text-xs text-red-600">{{ message }}</p>
          }
        </div>

        <!-- Warehouse Code -->
        <div class="relative">
          <input type="text" id="wearhouseCode" class="textField peer" placeholder=" "
                 [(ngModel)]="customer().wearhouseCode"
                 (ngModelChange)="updateField('wearhouseCode', $event)">
          <label class="label" for="wearhouseCode">Warehouse Code</label>
        </div>

        <!-- Tax Apply Checkbox -->
        <div class="flex items-center h-12">
          <input type="checkbox" id="isTaxApply"
                 [(ngModel)]="customer().isTaxApply"
                 (ngModelChange)="onTaxApplyChange($event)"
                 class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
          <label for="isTaxApply" class="ml-2 text-sm font-medium text-gray-900">Tax Apply</label>
        </div>

        <!-- BOI Registered Checkbox -->
        <div class="flex items-center h-12">
          <input type="checkbox" id="isBOIRegistered"
                 [(ngModel)]="customer().isBOIRegistered"
                 (ngModelChange)="updateField('isBOIRegistered', $event)"
                 class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
          <label for="isBOIRegistered" class="ml-2 text-sm font-medium text-gray-900">BOI Registered</label>
        </div>
      </div>
    </div>

    <div class="flex py-4 border-b"></div>
    <!-- Address Section - Only for Create Mode -->
    @if (!isUpdateCustomer()) {
      <div class="mb-6 mt-6">
  <div class="flex justify-between items-center mb-4">
    <h3 class="text-lg font-semibold text-gray-900">Addresses</h3>
    <div class="flex gap-2">
      <button (click)="addAddress()" type="button" class="button-blue">
        Add Address
      </button>
      @if (isUpdateCustomer()) {
        <button 
          (click)="updateAddresses()" 
          type="button" 
          class="button-green"
          [disabled]="customer().addresses.length === 0">
          Update Addresses
        </button>
      }
    </div>
  </div>

  @if (customer().addresses.length > 0) {
    <div class="space-y-4">
      @for (address of customer().addresses; track $index) {
        <div class="border border-gray-200 rounded-lg p-4 bg-gray-50">
          <div class="flex justify-between items-center mb-3">
            <h4 class="font-medium text-gray-700">Address {{ $index + 1 }}</h4>
            <button (click)="removeAddress($index)" type="button" 
                    class="text-red-600 hover:text-red-800 text-sm font-medium">
              Remove
            </button>
          </div>
          
          <div class="grid lg:grid-cols-4 md:grid-cols-2 xs:grid-cols-1 gap-4">
            <!-- Address Line One -->
            <div class="relative" [id]="'field-address-' + $index + '-addressLineOne'">
              <input type="text" [id]="'addressLineOne' + $index" class="textField peer" placeholder=" "
                     [class.!border-red-500]="errorFor('address-' + $index + '-addressLineOne')"
                     [(ngModel)]="address.addressLineOne"
                     (ngModelChange)="updateAddressField($index, 'addressLineOne', $event)"
                     required>
              <label class="label" [for]="'addressLineOne' + $index">
                Address Line One <span class="text-red-700">*</span>
              </label>
              @if (errorFor('address-' + $index + '-addressLineOne'); as message) {
              <p class="mt-1 text-xs text-red-600">{{ message }}</p>
              }
            </div>

            <!-- Address Line Two -->
            <div class="relative" [id]="'field-address-' + $index + '-addressLineTwo'">
              <input type="text" [id]="'addressLineTwo' + $index" class="textField peer" placeholder=" "
                     [class.!border-red-500]="errorFor('address-' + $index + '-addressLineTwo')"
                     [(ngModel)]="address.addressLineTwo"
                     (ngModelChange)="updateAddressField($index, 'addressLineTwo', $event)"
                     required>
              <label class="label" [for]="'addressLineTwo' + $index">
                Address Line Two <span class="text-red-700">*</span>
              </label>
              @if (errorFor('address-' + $index + '-addressLineTwo'); as message) {
              <p class="mt-1 text-xs text-red-600">{{ message }}</p>
              }
            </div>

            <!-- Address Line Three -->
            <div class="relative">
              <input type="text" [id]="'addressLineThree' + $index" class="textField peer" placeholder=" "
                     [(ngModel)]="address.addressLineThree"
                     (ngModelChange)="updateAddressField($index, 'addressLineThree', $event)">
              <label class="label" [for]="'addressLineThree' + $index">Address Line Three</label>
            </div>

            <!-- Country. The picker only commits a country when an option is clicked, so
                 this wrapper carries the ring and message for typed-but-unselected text. -->
            <div [id]="'field-address-' + $index + '-country'">
              <div class="rounded-lg" [class.ring-1]="errorFor('address-' + $index + '-country')"
                [class.ring-red-500]="errorFor('address-' + $index + '-country')">
                <app-search-country
                        [disabled]=false
                        [resetTrigger]="resetSearchTrigger()"
                        [countryInput]="address.country"
                        (selectCountry)="onCountryFieldSelected($index, 'country', $event)">
                </app-search-country>
              </div>
              @if (errorFor('address-' + $index + '-country'); as message) {
              <p class="mt-1 text-xs text-red-600">{{ message }}</p>
              }
            </div>

            <!-- Show As -->
            <div class="relative" [id]="'field-address-' + $index + '-show'">
              <input type="text" [id]="'show' + $index" class="textField peer" placeholder=" "
                     [class.!border-red-500]="errorFor('address-' + $index + '-show')"
                     [(ngModel)]="address.show"
                     (ngModelChange)="updateAddressField($index, 'show', $event)"
                     required>
              <label class="label" [for]="'show' + $index">Show As <span class="text-red-700">*</span></label>
              @if (errorFor('address-' + $index + '-show'); as message) {
              <p class="mt-1 text-xs text-red-600">{{ message }}</p>
              }
            </div>

            <!-- Checkboxes -->
            <div class="flex flex-col gap-2">
              <div class="flex items-center">
                <input type="checkbox" [id]="'useForInvoice' + $index"
                       [(ngModel)]="address.useForInvoice"
                       (ngModelChange)="updateAddressField($index, 'useForInvoice', $event)"
                       class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
                <label [for]="'useForInvoice' + $index" 
                       class="ml-2 text-sm font-medium text-gray-900">Available For Invoicing</label>
              </div>
              <div class="flex items-center">
                <input type="checkbox" [id]="'isDefaultInvoice' + $index"
                       [(ngModel)]="address.isDefaultInvoice"
                       (ngModelChange)="updateAddressField($index, 'isDefaultInvoice', $event)"
                       class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
                <label [for]="'isDefaultInvoice' + $index" 
                       class="ml-2 text-sm font-medium text-gray-900">Invoicing Make Default</label>
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <div class="flex items-center">
                <input type="checkbox" [id]="'useForDelivery' + $index"
                       [(ngModel)]="address.useForDelivery"
                       (ngModelChange)="updateAddressField($index, 'useForDelivery', $event)"
                       class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500">
                <label [for]="'useForDelivery' + $index" 
                       class="ml-2 text-sm font-medium text-gray-900">Available For Delivery</label>
              </div>

              <div class="flex items-center">
                <input type="checkbox" [id]="'isDefaultDelivery' + $index"
                       [(ngModel)]="address.isDefaultDelivery"
                       (ngModelChange)="onDeliveryDefaultChange($index, $event)"
                       [disabled]="!address.useForDelivery"
                       class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 disabled:opacity-50">
                <label [for]="'isDefaultDelivery' + $index" 
                       class="ml-2 text-sm font-medium text-gray-900">Delivery Make Default</label>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div id="field-addresses">
      <p class="text-gray-500 text-center py-4">No addresses added. Click "Add Address" to create one.</p>
      @if (errorFor('addresses'); as message) {
      <p class="text-center text-xs text-red-600 pb-2">{{ message }}</p>
      }
    </div>
  }
</div>

      <div class="flex py-4 border-b"></div>

      <!-- Contact Person Section -->
<div class="mb-6 mt-6">
  <div class="flex justify-between items-center mb-4">
    <h3 class="text-lg font-semibold text-gray-900">Contact Persons</h3>
    <div class="flex gap-2">
      <button (click)="addContactPerson()" type="button" class="button-blue">
        Add Contact Person
      </button>
      @if (isUpdateCustomer()) {
        <button 
          (click)="updateContactPersons()" 
          type="button" 
          class="button-green"
          [disabled]="customer().contactPersons.length === 0">
          Update Contact Persons
        </button>
      }
    </div>
  </div>

  @if (customer().contactPersons.length > 0) {
    <div class="space-y-4">
      @for (contact of customer().contactPersons; track $index) {
        <div class="border border-gray-200 rounded-lg p-4 bg-gray-50">
          <div class="flex justify-between items-center mb-3">
            <h4 class="font-medium text-gray-700">Contact Person {{ $index + 1 }}</h4>
            <button (click)="removeContactPerson($index)" type="button" 
                    class="text-red-600 hover:text-red-800 text-sm font-medium">
              Remove
            </button>
          </div>
          
          <div class="grid lg:grid-cols-4 md:grid-cols-2 xs:grid-cols-1 gap-4">
            <!-- Title -->
            <div [id]="'field-contact-' + $index + '-title'">
              <div class="rounded-lg" [class.ring-1]="errorFor('contact-' + $index + '-title')"
                [class.ring-red-500]="errorFor('contact-' + $index + '-title')">
                <app-search-person-title
                  [disabled]=false
                  [resetTrigger]="resetSearchTrigger()"
                  [PersonTitleInput]="contact.title"
                  (selectedPersonTitle)="onContactFieldSelected($index, 'title', $event)">
                </app-search-person-title>
              </div>
              @if (errorFor('contact-' + $index + '-title'); as message) {
              <p class="mt-1 text-xs text-red-600">{{ message }}</p>
              }
            </div>

            <!-- Contact Person Name -->
            <div class="relative" [id]="'field-contact-' + $index + '-contactPersonName'">
              <input type="text" [id]="'contactPersonName' + $index" class="textField peer" placeholder=" "
                     [class.!border-red-500]="errorFor('contact-' + $index + '-contactPersonName')"
                     [(ngModel)]="contact.contactPersonName"
                     (ngModelChange)="updateContactField($index, 'contactPersonName', $event)"
                     required>
              <label class="label" [for]="'contactPersonName' + $index">
                Contact Person Name <span class="text-red-700">*</span>
              </label>
              @if (errorFor('contact-' + $index + '-contactPersonName'); as message) {
              <p class="mt-1 text-xs text-red-600">{{ message }}</p>
              }
            </div>

            <!-- Designation -->
            <div class="relative">
              <input type="text" [id]="'contactPersonDesignation' + $index" class="textField peer" placeholder=" "
                     [(ngModel)]="contact.contactPersonDesignation"
                     (ngModelChange)="updateContactField($index, 'contactPersonDesignation', $event)"
                     required>
              <label class="label" [for]="'contactPersonDesignation' + $index">
                Designation
              </label>
            </div>

            <!-- Office Phone Number -->
            <div class="relative">
              <input type="tel" [id]="'contactPersonOfficePhoneNumber' + $index" class="textField peer" placeholder=" "
                     [(ngModel)]="contact.contactPersonOfficePhoneNumber"
                     (ngModelChange)="updateContactField($index, 'contactPersonOfficePhoneNumber', $event)" phoneNumberOnly>
              <label class="label" [for]="'contactPersonOfficePhoneNumber' + $index">Office Phone Number</label>
            </div>

            <!-- Mobile Number -->
            <div class="relative">
              <input type="tel" [id]="'contactPersonMobileNumber' + $index" class="textField peer" placeholder=" "
                     [(ngModel)]="contact.contactPersonMobileNumber"
                     (ngModelChange)="updateContactField($index, 'contactPersonMobileNumber', $event)" phoneNumberOnly>
              <label class="label" [for]="'contactPersonMobileNumber' + $index">Mobile Number</label>
            </div>

            <!-- Email -->
            <div class="relative" [id]="'field-contact-' + $index + '-contactPersonEmail'">
              <input type="emailAddress" [id]="'contactPersonEmail' + $index" class="textField peer" placeholder=" "
                     [class.!border-red-500]="errorFor('contact-' + $index + '-contactPersonEmail')"
                     [(ngModel)]="contact.contactPersonEmail"
                     (ngModelChange)="updateContactField($index, 'contactPersonEmail', $event)"
                     required>
              <label class="label" [for]="'contactPersonEmail' + $index">
                Email
              </label>
              @if (errorFor('contact-' + $index + '-contactPersonEmail'); as message) {
              <p class="mt-1 text-xs text-red-600">{{ message }}</p>
              }
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div id="field-contactPersons">
      <p class="text-gray-500 text-center py-4">No contact persons added. Click "Add Contact Person" to create one.</p>
      @if (errorFor('contactPersons'); as message) {
      <p class="text-center text-xs text-red-600 pb-2">{{ message }}</p>
      }
    </div>
  }
</div>
    }
<!-- <div class="flex py-4 border-b"></div> -->

<!-- Action Buttons -->
@if (isUpdateCustomer() && !customer().isActive) {
  <div class="mb-4">
    <p class="text-xs text-red-500">Customer is inactive. Toggle to enable.</p>
  </div>
}

<div class="flex justify-between items-center mt-6">
<div class="flex items-center">
  @if (authService.hasPermission('toggle-permission') && !isCustomerCreate) {
    <div class="flex items-center gap-3">
      <span class="text-sm font-medium text-gray-700">
        {{ customer().isActive === 1 ? 'Active' : 'Inactive' }}
      </span>
      <div class="relative inline-flex items-center group">
        <label class="relative inline-flex items-center"
               [class.cursor-pointer]="!isToggleDisabled()"
               [class.cursor-not-allowed]="isToggleDisabled()"
               [title]="isToggleDisabled() ? getToggleTooltipMessage() : ''">
          <input 
            type="checkbox" 
            [checked]="customer().isActive === 1"
            (change)="toggleCustomerStatus()"
            [disabled]="isToggleDisabled()"
            class="sr-only peer">
          <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-disabled:opacity-50 peer-disabled:cursor-not-allowed peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
        </label>
        
        @if (isToggleDisabled()) {
          <div class="absolute left-full ml-2 top-1/2 -translate-y-1/2 hidden group-hover:block z-10 pointer-events-none">
            <div class="bg-gray-900 text-white text-xs rounded py-2 px-3 whitespace-nowrap shadow-lg">
              {{ getToggleTooltipMessage() }}
              <div class="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-gray-900"></div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>

  <!-- Right side: Action buttons -->
  <div class="flex space-x-3">
    @if (isCustomerCreate) {
      <button (click)="cancel()" class="button-white">
        Clear
      </button>
    }
    
    <!-- Stays clickable so pressing it reports what is missing; createCustomer()
         still refuses to submit while anything is invalid. -->
    <button
      (mouseenter)="onDisabledButtonHover()"
      (click)="createCustomer()"
      class="button-blue">
      {{ customerService.active() ? 'Update' : 'Create' }}
    </button>
  </div>
</div>

        <!-- Address and Contact Management Buttons for Update Mode -->
    @if (isUpdateCustomer()) {
      <div class="mb-6 mt-6">
        <h3 class="text-lg font-semibold text-gray-900 mb-4">Additional Management</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          
          <!-- Manage Addresses Card -->
          <div class="border border-gray-200 rounded-lg p-6 bg-gray-50 hover:bg-gray-100 transition-colors">
            <div class="flex items-start justify-between mb-4">
              <div>
                <h4 class="text-lg font-semibold text-gray-900">Addresses</h4>
                <p class="text-sm text-gray-600 mt-1">
                  Manage customer delivery and invoicing addresses
                </p>
              </div>
              <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
            </div>
            <div class="flex items-center justify-between">
              <span class="text-sm text-gray-500">
                {{ customer().addresses.length }} address(es) on file
              </span>
              <button 
                (click)="navigateToAddressManagement()" 
                type="button" 
                class="button-blue">
                Manage Addresses
              </button>
            </div>
          </div>

          <!-- Manage Contact Persons Card -->
          <div class="border border-gray-200 rounded-lg p-6 bg-gray-50 hover:bg-gray-100 transition-colors">
            <div class="flex items-start justify-between mb-4">
              <div>
                <h4 class="text-lg font-semibold text-gray-900">Contact Persons</h4>
                <p class="text-sm text-gray-600 mt-1">
                  Manage customer contact information
                </p>
              </div>
              <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
            </div>
            <div class="flex items-center justify-between">
              <span class="text-sm text-gray-500">
                {{ customer().contactPersons.length }} contact(s) on file
              </span>
              <button 
                (click)="navigateToContactManagement()" 
                type="button" 
                class="button-blue">
                Manage Contacts
              </button>
            </div>
          </div>

        </div>
      </div>
    }
  </div>
</div>